import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const homepageBanner = document.querySelector('.homepageBanner');
const fadeInOnScroll = gsap.utils.toArray('.fadeInOnScroll');

if (homepageBanner) {

	window.addEventListener('load', () => {
		homepageBanner.classList.add('is-loaded');
	})
}

if (fadeInOnScroll) {

	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.batch(fadeInOnScroll, {
		toggleClass: "is-fading-in",
		once: true
	});
}